<template>
  <fade-in-main>
    <div class="work-contents-top">
      <div class="work-overflow">
        <slot></slot>
      </div>
    </div>
  </fade-in-main>
</template>

<script>
import FadeInMain from '@/components/FadeInMain.vue';

export default {
  components: { FadeInMain }
}
</script>

<style lang="scss">
.work-contents-top {
  margin: 50px auto 0;
}

.work-overflow {
  overflow: auto;
  height: 500px;
  box-sizing: border-box;
  background-color: #fff;
  img {
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
    width: 100%;
    &:hover {
      width: 98%;
      cursor: ns-resize;
    }
  }
}

</style>
